import app from "flarum/common/app";
import Component from "flarum/common/Component";
import Button from "flarum/common/components/Button";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import highlight from "flarum/common/helpers/highlight";
import { expired, fact, listing, permitted, request, t } from "../api";
import FactEditor from "./FactEditor";
import FactDetail from "./FactDetail";
import { rememberFeed, clearFeedSnapshot } from "../feedSnapshot";
const cache = new Map();
export function invalidateFacts() {
  clearFeedSnapshot();
  cache.clear();
}
export default class FactList extends Component {
  scope = "public";
  stories = [];
  next = null;
  loading = false;
  error = false;
  submitted = false;
  generation = 0;
  oninit(vnode) {
    super.oninit(vnode);
    this.scope = this.attrs.scope ?? "public";
    void this.load();
    this.timer = setInterval(() => {
      const active = this.stories.filter(s => !expired(s));
      if (active.length !== this.stories.length) {
        this.stories = active;
        m.redraw();
      }
    }, 1000);
  }
  onremove(vnode) {
    this.generation++;
    clearInterval(this.timer);
    super.onremove(vnode);
  }
  async load(more, force) {
    if (more === void 0) {
      more = false;
    }
    if (force === void 0) {
      force = false;
    }
    const generation = ++this.generation;
    this.loading = true;
    this.error = false;
    if (force) invalidateFacts();
    try {
      let entry = cache.get(this.scope);
      if (more || !entry || entry.until <= Date.now()) {
        entry = {
          until: Date.now() + 30000,
          response: request("?scope=" + this.scope + (more && this.next ? "&before=" + this.next : "")).then(v => listing(v, fact))
        };
        if (!more) cache.set(this.scope, entry);
      }
      const page = await entry.response;
      if (generation !== this.generation) return;
      this.stories = (more ? [...this.stories, ...page.data] : page.data).filter(s => !expired(s));
      this.next = page.next;
    } catch {
      if (generation === this.generation) {
        this.error = true;
        cache.delete(this.scope);
      }
    } finally {
      if (generation === this.generation) {
        this.loading = false;
        m.redraw();
      }
    }
  }
  changed() {
    invalidateFacts();
    void this.load(false, true);
  }
  view() {
    return m("section", {
      className: "FactList " + (this.attrs.compact ? "FactList--compact" : ""),
      "aria-label": String(t("stories"))
    }, m("div", {
      className: "FactList-toolbar"
    }, m("strong", null, t("stories")), m(Button, {
      className: "Button Button--text",
      disabled: this.loading,
      onclick: () => this.load(false, true)
    }, t("refresh")), !this.attrs.compact && m("select", {
      className: "FormControl",
      "aria-label": String(t("filter")),
      value: this.scope,
      onchange: e => {
        this.scope = e.target.value;
        this.stories = [];
        this.selected = undefined;
        void this.load();
      }
    }, m("option", {
      value: "public"
    }, t("public")), app.session.user && m("option", {
      value: "mine"
    }, t("mine")), permitted("canModerate") && m("option", {
      value: "pending"
    }, t("moderation")))), this.submitted && m("p", {
      role: "status"
    }, t("submitted")), this.error && m("p", {
      role: "alert"
    }, t("load_error"), " ", m(Button, {
      className: "Button",
      onclick: () => this.load(false, true)
    }, t("retry"))), m("div", {
      className: "FactList-scroll",
      tabindex: 0,
      role: "region",
      "aria-label": String(t("stories"))
    }, permitted("canCreate") && m("button", {
      type: "button",
      className: "FactCard FactCard--create",
      onclick: () => app.modal.show(FactEditor, {
        onsaved: () => {
          this.submitted = true;
          if (!this.attrs.compact) this.scope = "mine";
          this.changed();
        }
      })
    }, m("span", {
      className: "FactCard-plus"
    }, "+"), m("span", null, t("create"))), !app.session.user && m("button", {
      type: "button",
      className: "FactCard FactCard--create",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, m("span", {
      className: "FactCard-plus"
    }, "+"), m("span", null, t("create"))), this.stories.map(story => {
      const content = story.author.name.charAt(0).toUpperCase();
      return m("button", {
        type: "button",
        key: story.id,
        className: "FactCard Fact-gradient--" + story.background,
        onclick: () => {
          if (this.scope === "public") rememberFeed(this.stories, this.next);
          if (this.attrs.open) this.attrs.open(story);else this.selected = story.id;
        }
      }, m("span", {
        className: "FactCard-picture"
      }, story.images[0] ? m("img", {
        src: story.images[0].url,
        alt: "",
        loading: "lazy"
      }) : m("span", {
        className: "FactCard-text"
      }, highlight(story.content, undefined, 40))), m("span", {
        className: "FactCard-logo",
        "aria-hidden": "true"
      }, story.author.avatar ? m("img", {
        src: story.author.avatar,
        alt: ""
      }) : content), m("span", {
        className: "FactCard-name"
      }, story.author.name), story.status !== "approved" && m("span", {
        className: "FactCard-status"
      }, t(story.status)));
    }), this.next && m(Button, {
      className: "Button FactList-more",
      loading: this.loading,
      onclick: () => this.load(true)
    }, t("more"))), this.loading && m(LoadingIndicator, null), !this.loading && !this.error && !this.stories.length && m("p", {
      className: "helpText"
    }, t("empty")), this.selected && m("div", {
      className: "FactList-detail"
    }, m(FactDetail, {
      key: this.selected,
      id: this.selected,
      onchanged: () => this.changed()
    })));
  }
}
flarum.reg.add('xgay-fact', 'common/components/FactList', FactList);